import React, { JSX } from 'react'
import { UserIcon } from '@heroicons/react/24/solid'
import { EmptyDataCard } from './EmptyDataCard'

export interface IconArrayProps {
  percentage?: number
  title: string
  caption: string
}

export const IconArrayChart = ({ percentage, title, caption }: IconArrayProps): JSX.Element => {
  const validPercentage = Math.max(0, Math.min(100, percentage ?? 0))
  const icons = Array.from({ length: 100 })
  const amountOfIcons = validPercentage < 1 ? Math.ceil(validPercentage) : Math.round(validPercentage)
  if (percentage == null) {
    return (
      <div className='mt-4 md:mx-0 rounded-none md:rounded-2xl overflow-hidden'>
        <EmptyDataCard message='No sales reported for specified filters' />
      </div>
    )
  }

  return (
    <>
      <div className='pt-2 px-4 mb-4'>
        <h2 className='text-sm font-medium dark:text-gray-300'>{title}</h2>
        <p className='text-3xl sm:text-4xl font-semibold text-brand mt-1'>
          {validPercentage}%
        </p>
        <span className=' text-sm mt-2'>
          {amountOfIcons} {caption}
        </span>
      </div>

      <div className='px-4 pb-3 grid grid-cols-10 gap-2 '>
        {icons.map((_, index) => {
          const isHighlighted = index < validPercentage
          return (
            <UserIcon
              key={index}
              className={`w-5 h-5 transition-colors duration-300 ${
                isHighlighted ? 'text-brand' : 'text-lm-bg-accent dark:text-dm-bg-accent'
              }`}
            />
          )
        })}
      </div>
    </>
  )
}
